import axios from "axios";

const BASE_URL = `/m-1/notices`;

/**
 * Serwis do komunikacji z API - endpoint /notices
 */
export const NoticesService = {
  fetchStatus,
  updateStatus,
};

function fetchStatus(state) {
  return axios.get(`${BASE_URL}/${state}`);
}

function updateStatus(state, data) {
  return axios.put(`${BASE_URL}/${state}`, data);
}
